<template>
  <div class="bottom-of-booking">
    <BottomBar @save="$emit('storeBooking')" :valid="valid" :saving="saving" :backRouterLink="{ name: 'overview' }" :actionText="actionText" :darkMode="darkMode">
      <div v-if="conflict" class="conflict f5">
        <div>{{ $t('You have selected a setup that will cause a scheduling conflict.') }} {{ $t('You can still book this reservation, however.') }}</div>
      </div>
      <SummaryGrid
        :locationId="locationId"
        :startTime="startTime"
        :booking="booking"
        :bookingStationTimesWithoutRemoved="bookingStationTimesWithoutRemoved"
        :twentyFourHourTime="twentyFourHourTime"
        :longestTierLength="longestTierLength"
        :isOrganizationEducation="isOrganizationEducation"
        :darkMode="darkMode"
        v-on="$listeners"
      />
    </BottomBar>
  </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import BottomBar from '@/core/shared/components/BottomBar';
import SummaryGrid from './SummaryGrid';

@Component({
  props: {
    locationId: {
      type: String,
      required: true,
    },
    booking: {
      type: Object,
      required: true,
    },
    bookingStationTimesWithoutRemoved: {
      type: Array,
      required: true,
    },
    canProceedWithConflict: {
      type: Boolean,
      required: false,
    },
    conflict: {
      type: Boolean,
      required: true,
    },
    longestTierLength: {
      type: Number,
      required: true,
    },
    twentyFourHourTime: {
      type: Boolean,
      required: true,
    },
    startTime: {
      type: String,
      required: true,
    },
    isOrganizationEducation: {
      type: Boolean,
      default: false,
    },
    saving: {
      type: Boolean,
      default: false,
    },
    darkMode: {
      type: Boolean,
      required: false,
    },
  },
  components: {
    BottomBar,
    SummaryGrid,
  },
})
export default class BottomOfReservation extends Vue {
  get valid () {
    if (this.booking.notifyHost && !this.booking.host.email) return false;
    if (this.booking.bookingStationTimes.length < 1) return false;
    if (!this.canProceedWithConflict) return !this.conflict;
    return true;
  }

  get actionText () {
    return (this.booking._startNow) ? this.$t('Start Now') : this.$t('Save');
  }
}
</script>

<style scoped lang="postcss">
@import 'core/shared/styles';

.bottom-of-booking {
  @media (--desktop) {
    z-index: calc(var(--zContent) + 1);
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
  }

  & .conflict {
    position: absolute;
    padding: var(--spacingXS);
    background-color: var(--colorErrorFlat);
    color: var(--colorWhite);
    text-align: center;
    top: -3rem;
    left: 0;
    width: 100%;
    margin: 0;
  }

  & .summary-grid {
    display: none;

    @media (--tablet) {
      display: flex;
    }
  }
}
</style>
